import React, { useState, useEffect, useContext, useRef, use } from 'react';
import { Box, Button, Grid, Typography } from '@mui/material';
import { AppContext } from '../../../context/Context';
import { useTranslation } from 'react-i18next';
import '../../../assets/css/buttons.css';
import {
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
} from '@mui/icons-material/';

import Logo from '../../../assets/img/clubhouse_logo.png';
import LogoOK from '../../../assets/img/okbingo.png';
import LogoWin from '../../../assets/img/wingames.png';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

const glassBg = 'rgba(255,255,255,0.06)';
const glassBorder = '1px solid rgba(255,255,255,0.14)';
const accent = '#FFC727';

function ModalTicketInfo() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const {
    updateIsLoginRefill,
    updateTicketSelectedKioskCH,
    updateTicketSelectedKioskWG,
    updateTicketSelectedKioskOK,
    updateCurrentTicketOK,
    updateCurrentTicketWG,
    updateShowModalTicketInfoKiosk,
    ticketInfoKiosk,
    updateTicketInfoKiosk,
    updateUserLogin,
    updateUserInfo,
    updateCurrentUser,
    updateCurrentUserID,
    updateUserChildren,
    updateIsLoadingScreen,
  } = useContext(AppContext);

  const ticketInfoKioskRef = useRef(ticketInfoKiosk);
  useEffect(() => {
    console.log('ticketInfoKiosk updated:', ticketInfoKiosk);
    ticketInfoKioskRef.current = ticketInfoKiosk;
  }, [ticketInfoKiosk]);

  const [pinCode, setPinCode] = useState('');
  const [userPinCode, setUserPinCode] = useState('');
  useEffect(() => {
    if (!ticketInfoKiosk) {
      return;
    }
    if (pinCode.length !== 4) {
      return;
    }
    if (pinCode === userPinCode && userPinCode !== '') {
      if (ticketInfoKioskRef.current.provider === 'wg') {
        handleLoginWG();
        return;
      }
      if (ticketInfoKioskRef.current.provider === 'okd') {
        handleLoginOKD();
        return;
      }
      handleLogin();
    } else {
      toast.error(t('kiosk.infoTicketErrorPinMessage'));
      setPinCode('');
    }
  }, [pinCode]);

  useEffect(() => {
    if (!ticketInfoKiosk) {
      return;
    }

    if (ticketInfoKiosk.provider === 'wg') {
      setUserPinCode(ticketInfoKiosk.records[0]['PIN2']);
      return;
    }
    if (ticketInfoKiosk.provider === 'okd') {
      setUserPinCode(ticketInfoKiosk.records[0]['PIN2']);
      return;
    }
    if (ticketInfoKiosk.provider === 'ch') {
      setUserPinCode(ticketInfoKioskRef.current.parent.userInfo['PIN2']);
      return;
    }
  }, [ticketInfoKiosk]);

  const handleKeypad = (key) => {
    if (key === 'back') {
      setPinCode((prev) => prev.slice(0, -1));
      return;
    }
    if (key === 'clear') {
      setPinCode('');
      return;
    }
    if (pinCode.length >= 4) return;
    setPinCode((prev) => prev + key);
  };

  const handleCancel = () => {
    updateTicketInfoKiosk(false);
    updateShowModalTicketInfoKiosk(false);
    setPinCode('');
  };

  const handleConfirm = () => {
    if (!pinCode || pinCode !== ticketInfoKiosk.parent.userInfo['PIN2']) {
      toast.error(t('kiosk.infoTicketErrorPinMessage'));
      return;
    }
    handleLogin();
  };

  const handleLogin = () => {
    updateUserLogin(true);
    updateUserInfo(ticketInfoKiosk.parent.userInfo);
    updateCurrentUser(ticketInfoKiosk.parent.userInfo['7 digit PIN']);
    updateCurrentUserID(ticketInfoKiosk.parent.userInfo['id']);
    const mainRecord = ticketInfoKiosk.records[0];
    const children = [
      {
        ticket7Pincode: mainRecord['7 digit PIN'],
        ticketID: mainRecord.id,
        ticketUsername: mainRecord.username,
        amount: mainRecord.balances.wallet,
      },
    ];

    updateTicketSelectedKioskCH(children[0]);

    if (ticketInfoKiosk.siblings && ticketInfoKiosk.siblings.length > 0) {
      for (const sibling of ticketInfoKiosk.siblings) {
        if (parseInt(sibling.ticketID) !== parseInt(mainRecord.id)) {
          children.push({
            ticket7Pincode: sibling.ticket7Pincode,
            ticketID: sibling.ticketID,
            ticketUsername: sibling.ticketUsername,
            amount: sibling.amount,
          });
        }
      }
    }

    updateUserChildren(children);

    updateIsLoadingScreen(false);
    updateTicketInfoKiosk(false);
    updateIsLoginRefill('ch');
    updateShowModalTicketInfoKiosk(false);
    setPinCode('');

    navigate('/salgs-kiosk');
  };

  const handleLoginWG = () => {
    console.log('Logging in with WG ticket:', ticketInfoKiosk);
    updateUserLogin(true);
    updateUserInfo(ticketInfoKiosk.records[0]);
    updateCurrentUser(ticketInfoKiosk.records[0]['7 digit PIN']);
    updateCurrentUserID(ticketInfoKiosk.records[0]['id']);

    updateTicketSelectedKioskWG(ticketInfoKiosk.ticket);
    updateCurrentTicketWG(ticketInfoKiosk.ticket);

    updateUserChildren(ticketInfoKiosk.children);

    updateIsLoadingScreen(false);
    updateTicketInfoKiosk(false);
    updateIsLoginRefill('wg');
    updateShowModalTicketInfoKiosk(false);
    setPinCode('');

    navigate('/salgs-kiosk');
  };

  const handleLoginOKD = () => {
    updateUserLogin(true);
    updateUserInfo(ticketInfoKiosk.records[0]);
    updateCurrentUser(ticketInfoKiosk.records[0]['7 digit PIN']);
    updateCurrentUserID(ticketInfoKiosk.records[0]['id']);

    updateTicketSelectedKioskOK({
      okID: ticketInfoKiosk.okID,
      amount: ticketInfoKiosk.currentBalance,
    });
    updateCurrentTicketOK({
      okID: ticketInfoKiosk.okID,
      amount: ticketInfoKiosk.currentBalance,
    });
    updateUserChildren(ticketInfoKiosk.children);

    updateIsLoadingScreen(false);
    updateTicketInfoKiosk(false);
    updateIsLoginRefill('okd');
    updateShowModalTicketInfoKiosk(false);
    setPinCode('');

    navigate('/salgs-kiosk');
  };

  const getProviderLogo = (provider) => {
    if (provider === 'okd') return LogoOK;
    if (provider === 'wg') return LogoWin;
    return Logo;
  };

  const keypadKeys = [
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'back',
    '0',
    'clear',
  ];

  const isUsed = ticketInfoKiosk?.status === 'used';

  if (ticketInfoKiosk === 'closed') {
    return (
      <div id="react-confirm-alert">
        <div
          className="react-confirm-alert-overlay"
          style={{
            background: 'rgba(3,6,18,0.88)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div
            style={{
              width: 'min(1100px, 94vw)',
              height: 'min(820px, 90vh)',
              borderRadius: '24px',
              overflow: 'hidden',
              border: '1px solid rgba(255,255,255,0.12)',
              boxShadow: '0 30px 90px rgba(0,0,0,0.65)',
              background:
                'linear-gradient(135deg, rgba(18,26,55,0.98), rgba(10,14,28,0.98))',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            {/* Header */}
            <Box
              sx={{
                height: 70,
                px: '24px',
                display: 'flex',
                alignItems: 'center',
                borderBottom: '1px solid rgba(255,255,255,0.10)',
                background:
                  'linear-gradient(135deg, rgba(255,255,255,0.06), rgba(255,255,255,0.02))',
                flexShrink: 0,
              }}
            >
              <Typography
                sx={{
                  color: 'white',
                  fontSize: '24px',
                  fontWeight: 900,
                  lineHeight: 1,
                }}
              >
                {t('kiosk.closedTicketTitle')}
              </Typography>
            </Box>

            {/* Body */}
            <Box
              sx={{
                display: 'flex',
                flex: 1,
                p: '24px',
                flexDirection: 'column',
                gap: '20px',
                minHeight: 0,
              }}
            >
              {/* Message */}
              <Box
                sx={{
                  flex: 1,
                  borderRadius: '18px',
                  border: glassBorder,
                  background: glassBg,
                  p: '28px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '24px',
                }}
              >
                <CancelIcon
                  sx={{ fontSize: 90, color: '#ff4d4f', opacity: 0.9 }}
                />
                <Typography
                  sx={{
                    color: 'white',
                    fontWeight: 800,
                    fontSize: 32,
                    textAlign: 'center',
                  }}
                >
                  {t('kiosk.closedTicketMessage1')}
                </Typography>
                <Typography
                  sx={{
                    color: 'rgba(255,255,255,0.65)',
                    fontSize: 25,
                    textAlign: 'center',
                  }}
                >
                  {t('kiosk.closedTicketMessage2')}
                </Typography>
              </Box>

              {/* Cancel button */}
              <Box sx={{ flexShrink: 0 }}>
                <Button
                  fullWidth
                  variant="contained"
                  onClick={handleCancel}
                  startIcon={<CancelIcon sx={{ fontSize: 34 }} />}
                  sx={{
                    height: 88,
                    borderRadius: '16px',
                    bgcolor: 'rgba(255,255,255,0.08)',
                    color: 'rgba(255,255,255,0.75)',
                    fontWeight: 800,
                    fontSize: 22,
                    textTransform: 'uppercase',
                    border: glassBorder,
                    boxShadow: 'none',
                    '&:hover': {
                      bgcolor: 'rgba(255,255,255,0.14)',
                      transform: 'translateY(-2px)',
                      color: 'white',
                    },
                    '&:active': { transform: 'translateY(0)' },
                  }}
                >
                  {t('sales.cancel')}
                </Button>
              </Box>
            </Box>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div id="react-confirm-alert">
      <div
        className="react-confirm-alert-overlay"
        style={{
          background: 'rgba(3,6,18,0.88)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div
          style={{
            width: 'min(1100px, 94vw)',
            height: 'min(820px, 90vh)',
            borderRadius: '24px',
            overflow: 'hidden',
            border: '1px solid rgba(255,255,255,0.12)',
            boxShadow: '0 30px 90px rgba(0,0,0,0.65)',
            background:
              'linear-gradient(135deg, rgba(18,26,55,0.98), rgba(10,14,28,0.98))',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {/* Header */}
          <Box
            sx={{
              height: 70,
              px: '24px',
              display: 'flex',
              alignItems: 'center',
              borderBottom: '1px solid rgba(255,255,255,0.10)',
              background:
                'linear-gradient(135deg, rgba(255,255,255,0.06), rgba(255,255,255,0.02))',
              flexShrink: 0,
            }}
          >
            <Typography
              sx={{
                color: 'white',
                fontSize: '24px',
                fontWeight: 900,
                lineHeight: 1,
              }}
            >
              {ticketInfoKiosk
                ? t('kiosk.infoTicketTitle')
                : t('kiosk.infoTicketErrorTitle')}
            </Typography>
          </Box>

          {/* Body */}
          <Box
            sx={{
              display: 'flex',
              flex: 1,
              p: '24px',
              gap: '20px',
              minHeight: 0,
            }}
          >
            {/* LEFT: PIN + keypad */}
            <Box
              sx={{
                flex: '0 0 380px',
                display: 'flex',
                flexDirection: 'column',
                gap: '20px',
              }}
            >
              {/* 4-dot PIN display */}
              <Box
                sx={{
                  borderRadius: '18px',
                  border: glassBorder,
                  background: glassBg,
                  p: '22px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '24px',
                }}
              >
                {[0, 1, 2, 3].map((i) => (
                  <Box
                    key={i}
                    sx={{
                      width: 28,
                      height: 28,
                      borderRadius: '50%',
                      border: `2.5px solid ${pinCode.length > i ? accent : 'rgba(255,255,255,0.25)'}`,
                      background: pinCode.length > i ? accent : 'transparent',
                      transition: 'all 0.15s ease',
                      boxShadow:
                        pinCode.length > i ? `0 0 14px ${accent}88` : 'none',
                    }}
                  />
                ))}
              </Box>

              {/* Keypad */}
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(3, 1fr)',
                  gap: '12px',
                  flex: 1,
                }}
              >
                {keypadKeys.map((key) => (
                  <Button
                    key={key}
                    variant="contained"
                    onClick={() => handleKeypad(key)}
                    sx={{
                      height: 135,
                      borderRadius: '16px',
                      fontSize: key === 'back' || key === 'clear' ? 24 : 34,
                      fontWeight: 700,
                      textTransform: 'none',
                      color: 'white',
                      border: glassBorder,
                      background:
                        key === 'clear'
                          ? 'rgba(255,255,255,0.08)'
                          : 'linear-gradient(180deg, rgba(255,255,255,0.12), rgba(255,255,255,0.06))',
                      boxShadow: '0 6px 16px rgba(0,0,0,0.3)',
                      '&:hover': {
                        background:
                          key === 'clear'
                            ? 'rgba(255,255,255,0.14)'
                            : 'linear-gradient(180deg, rgba(255,255,255,0.18), rgba(255,255,255,0.10))',
                        transform: 'translateY(-2px)',
                      },
                      '&:active': { transform: 'translateY(0)' },
                    }}
                  >
                    {key === 'back'
                      ? '⌫'
                      : key === 'clear'
                        ? t('kiosk.clear') || 'Clear'
                        : key}
                  </Button>
                ))}
              </Box>
            </Box>

            {/* RIGHT: ticket info + confirm */}
            <Box
              sx={{
                flex: 1,
                minWidth: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: '20px',
              }}
            >
              {/* Info card */}
              <Box
                sx={{
                  flex: 1,
                  borderRadius: '18px',
                  border: glassBorder,
                  background: glassBg,
                  p: '28px',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '18px',
                }}
              >
                {ticketInfoKiosk ? (
                  <>
                    {/* Logo */}
                    <Box
                      sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}
                    >
                      <Box
                        component="img"
                        src={getProviderLogo(ticketInfoKiosk.provider)}
                        alt="provider logo"
                        sx={{ maxHeight: 80, objectFit: 'contain' }}
                      />
                    </Box>

                    {isUsed ? (
                      <Typography
                        sx={{ color: accent, fontWeight: 800, fontSize: 28 }}
                      >
                        {t('kiosk.usedTicketMessage1')}
                      </Typography>
                    ) : (
                      <Typography
                        sx={{ color: 'white', fontWeight: 700, fontSize: 28 }}
                      >
                        {t('kiosk.infoTicketMessage1')}{' '}
                        <Box
                          component="span"
                          sx={{ color: accent, fontSize: 33 }}
                        >
                          {ticketInfoKiosk.currentBalance} KR.
                        </Box>
                      </Typography>
                    )}

                    <Typography
                      sx={{ color: 'rgba(255,255,255,0.65)', fontSize: 25 }}
                    >
                      {t('kiosk.infoTicketMessage2')}
                    </Typography>

                    <Typography
                      sx={{ color: 'rgba(255,255,255,0.65)', fontSize: 25 }}
                    >
                      {t('kiosk.infoTicketMessage3')}
                    </Typography>
                  </>
                ) : (
                  <Typography
                    sx={{ color: 'rgba(255,255,255,0.65)', fontSize: 25 }}
                  >
                    {t('kiosk.infoTicketErrorMessage')}
                  </Typography>
                )}
              </Box>

              {/* Action buttons */}
              <Box sx={{ flexShrink: 0 }}>
                <Button
                  fullWidth
                  variant="contained"
                  onClick={handleCancel}
                  startIcon={<CancelIcon sx={{ fontSize: 34 }} />}
                  sx={{
                    height: 88,
                    borderRadius: '16px',
                    bgcolor: 'rgba(255,255,255,0.08)',
                    color: 'rgba(255,255,255,0.75)',
                    fontWeight: 800,
                    fontSize: 22,
                    textTransform: 'uppercase',
                    border: glassBorder,
                    boxShadow: 'none',
                    '&:hover': {
                      bgcolor: 'rgba(255,255,255,0.14)',
                      transform: 'translateY(-2px)',
                      color: 'white',
                    },
                    '&:active': { transform: 'translateY(0)' },
                  }}
                >
                  {t('sales.cancel')}
                </Button>
              </Box>
            </Box>
          </Box>
        </div>
      </div>
    </div>
  );
}

export default ModalTicketInfo;
